<template>
    <div class="mb-5">
        <h5 class="card-title">Sponsors</h5>
        <div class="row mt-3">
            <a class="col-md-3 mb-3 mb-md-4" v-for="sponsor in displaySponsors" :key="sponsor.id" :href="sponsor.company.website" target="_blank" :title="sponsor.company.about">
                <div class="card">
                    <img :src="sponsor.company.picture" :alt="sponsor.company.name">
                </div>
            </a>
        </div>
        
        <see-more-button 
            v-if="sponsors.length > 2" 
            :count="sponsors.length - 2"
            @showMore="(status) => showMore = status"
        ></see-more-button>
    </div>
</template>

<script>
import SeeMoreButton from  '../global/SeeMoreButton';

export default {
    name: 'network-sponsors-card',

    components: {
        SeeMoreButton,
    },

    props: {
        sponsors: {
            type: Array,
            default: []
        }
    },

    data() {
        return {
            showMore: false,
        }
    },

    computed: {
        displaySponsors() {
            return (this.showMore) ? this.sponsors : this.sponsors.slice(0, 4);
        }
    }
}
</script>

<style lang="scss" scoped>
.card {
    background-color: #ffffff;
    padding: 20px;
    text-align: center;
    align-items: center;
    height: 100%;
}

img {
    filter: grayscale(1);
    max-width: 100%;
    width: 100px;

    &:hover {
        filter: none;
    }
    @include media-breakpoint-up(md) {
        width: 84px;
    }
}
</style>
